import { render, staticRenderFns } from "./group-post-edit.vue?vue&type=template&id=50ba5613&scoped=true"
import script from "./group-post-edit.vue?vue&type=script&lang=js"
export * from "./group-post-edit.vue?vue&type=script&lang=js"
import style0 from "./group-post-edit.vue?vue&type=style&index=0&id=50ba5613&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ba5613",
  null
  
)

export default component.exports